import htmlComponent from 'htmlcomponent'

export default function (dom, opts) {
		let options = {
			...opts
		};

    function init() {

			 const imgs = Array.from(dom.querySelectorAll('img'));
        if (imgs.length <= 1) return;

        let idx = 0;
        imgs.forEach((img, i) => {
            img.style.opacity = i === 0 ? '1' : '0';
            img.style.transition = 'opacity 0.5s ease';
        });

        setInterval(() => {
            const prev = idx;
            idx = (idx + 1) % imgs.length;
            imgs[prev].style.opacity = '0';
            imgs[idx].style.opacity = '1';
        }, 1000);
    }

    init();

}
